import { connect } from 'react-redux';

import {
  actionCreateInternalAccount,
  actionUpdateInternalAccount,
  actionGetInternalAccountDetail,
  actionResetInternalAccountDetail,
} from 'store/manageAccount/actions';

import ModalAddInternalAccount from './ModalAddInternalAccount';

const mapStateToProps = (state) => ({
  isLoadingCreateInternalAccount: state.ManageAccount.isLoadingCreateInternalAccount,
  isLoadingUpdateInternalAccount: state.ManageAccount.isLoadingUpdateInternalAccount,
  isLoadingGetInternalAccountDetail: state.ManageAccount.isLoadingGetInternalAccountDetail,
  internalAccountDetail: state.ManageAccount.internalAccountDetail,
});

const mapDispatchToProps = (dispatch) => ({
  actionCreateInternalAccount: (payload) => dispatch(actionCreateInternalAccount(payload)),
  actionUpdateInternalAccount: (payload) => dispatch(actionUpdateInternalAccount(payload)),
  actionGetInternalAccountDetail: (payload) => dispatch(actionGetInternalAccountDetail(payload)),
  actionResetInternalAccountDetail: () => dispatch(actionResetInternalAccountDetail()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalAddInternalAccount);
